export const startsWithAny = ( value, prefixes ) => prefixes.some( prefix => value.indexOf( prefix ) === 0 );

export const removeStorageEntries = prefixes => {
	[ window.localStorage, window.sessionStorage ].forEach( storage => {
		Object.keys( storage )
			.filter( key => startsWithAny( key, prefixes ))
			.forEach( key => storage.removeItem( key ));
	});
}
